import type { AllRouteEndpoints } from "../routeTypes";
export const appSettingsAppGroupIdMessagePrioritizationRulesValidationCacheKeys: AllRouteEndpoints[] = [];
